import { Container } from '@mui/material'
import Body from 'components/common/Body'
import Filters from 'components/SupportHeadList/Filters'
import SubHeader from 'components/layout/SubHeader'
import ApplicationFooter from 'components/layout/ApplicationFooter'
import BusinessUnitSelector from 'components/common/BusinessUnitSelector'
import MembersList from 'components/SupportHeadList/MembersList'
import { ISearchMyStaffParams } from 'interfaces'
import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import {
  selectSelectedBusinessUnits,
  selectSupportHeadSelectedFilters,
  selectSupportHeadSelectedJobRole,
  selecSupportHeadSelectedSearchString,
  selectSupportHeadTableConfig,
  useAppSelector,
  useAppDispatch,
  setSupportHeadSearchString,
} from 'store'

import { useLazySearchSupportHeadsListQuery } from 'store/api'
import { removeEmptyValues } from 'utils/objectHandlers'

const SupportlHeadList = () => {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const q = searchParams.get('q')
  const dispatch = useAppDispatch()

  const [shouldRefetch, setShouldRefetch] = useState(false)
  const selectedFilters = useAppSelector(selectSupportHeadSelectedFilters)
  const tableConfig = useAppSelector(selectSupportHeadTableConfig)
  const selectedJobRole = useAppSelector(selectSupportHeadSelectedJobRole)
  const selectedSearchString = useAppSelector(selecSupportHeadSelectedSearchString)
  const selectedBusinessUnits = useAppSelector(selectSelectedBusinessUnits)

  const selectedBusinesUnitsValues = selectedBusinessUnits.map(bu => bu.value)

  const myStaffFilters: ISearchMyStaffParams = {
    ...tableConfig,
    ...selectedFilters,
    searchTerm: selectedSearchString,
    jobRoles: selectedJobRole,
    businessUnits: selectedBusinesUnitsValues,
  }

  const [getSupportHeadList, { data: safetyAccompanyingData, isFetching }] =
    useLazySearchSupportHeadsListQuery()

  const handleSearchSupportHeadList = () => {
    try {
      getSupportHeadList(removeEmptyValues(myStaffFilters))
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleSearchSupportHeadList()
  }, [tableConfig, shouldRefetch])

  useEffect(() => {
    if (id || q) {
      dispatch(setSupportHeadSearchString(q || id || ''))
      setShouldRefetch(!shouldRefetch)
    }
  }, [id, q])

  if (!safetyAccompanyingData) return null
  const { records, totalPages, totalRecords } = safetyAccompanyingData

  return (
    <>
      <Body>
        <SubHeader
          breadcrumbItems={[
            {
              text: <FormattedMessage id="app.labels.dashboard" />,
              href: '/dashboard',
            },
            {
              text: <FormattedMessage id="app.labels.supportHeadList" />,
              href: '/view-safety-accompanying-person-list',
            },
          ]}
        >
          <BusinessUnitSelector
            setShouldRefetch={setShouldRefetch}
            shouldRefetch={shouldRefetch}
          />
        </SubHeader>
        <Filters setShouldRefetch={setShouldRefetch} shouldRefetch={shouldRefetch} />

        <Container>
          <MembersList
            isLoading={isFetching}
            records={records}
            totalPages={totalPages}
            totalRecords={totalRecords}
          />
        </Container>
      </Body>
      <ApplicationFooter />
    </>
  )
}

export default SupportlHeadList
